import React from 'react';
import { ModalBody, ServiceSelectionSubtitle } from '../styles/modalStyles';
import { ServiceCard } from './ServiceCard';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import { useAdditionalServicesContext } from '../AdditionalServicesContext';

export const ConfirmationStep = ({
  selectedServices,
  services,
  servicesWithUpdatedValues,
  getTotalPrice,
  onBack,
  onClose,
  onConfirm,
  onRequestOtherServices,
  isMobile = false,
}) => {
  const { isConfirmingServices, hasAvailableServices } = useAdditionalServicesContext();
  return (
    <>
      <ModalHeader
        title="Confirmar Solicitação"
        onBack={onBack}
        onClose={onClose}
        isMobile={isMobile}
      />
      <ModalBody>
        <ServiceSelectionSubtitle>
          Deseja confirmar a solicitação dos serviços abaixo?
        </ServiceSelectionSubtitle>

        {selectedServices.map(serviceKey => {
          const service =
            servicesWithUpdatedValues.find(s => s.key === serviceKey) ||
            services.find(s => s.key === serviceKey);
          const displayTitle =
            service.key === '02' && service.selectedWarrantyOption
              ? `${service.title} - ${service.selectedWarrantyOption.title}`
              : service.title;

          return (
            <ServiceCard
              key={serviceKey}
              service={{ ...service, title: displayTitle }}
              isSelected={true}
              showActions={false}
            />
          );
        })}
      </ModalBody>
      <ModalFooter
        totalPrice={getTotalPrice()}
        primaryButtonText={isConfirmingServices ? 'Confirmando...' : 'Confirmar solicitação'}
        primaryButtonDisabled={isConfirmingServices}
        onPrimaryClick={onConfirm}
        secondaryLinkText={hasAvailableServices && !isMobile ? 'Solicitar outros serviços' : null}
        onSecondaryClick={hasAvailableServices && !isMobile ? onRequestOtherServices : undefined}
      />
    </>
  );
};
